import {AlertFillIcon} from '@primer/octicons-react'
import CircleOcticon from '@github-ui/circle-octicon'
import {HEADER_ICON_SIZE} from '../../../constants'

export function AlertIcon({
  bgColor = 'var(--bgColor-neutral-emphasis)',
  color = 'var(--fgColor-onEmphasis)',
}: {
  bgColor?: string
  color?: string
}) {
  return (
    <CircleOcticon
      icon={() => <AlertFillIcon size={16} />}
      size={HEADER_ICON_SIZE}
      style={{background: bgColor, color}}
    />
  )
}

try{ AlertIcon.displayName ||= 'AlertIcon' } catch {}